const detailFoodStyle = {
  boxPaper: {
    position: 'fixed',
    zIndex: 2,
    bottom: 0,
    width: '100%',
    height: '100%',
    margin: 0,
    borderRadius: 0,
    // borderTopRightRadius: '25px',
    // borderTopLeftRadius: '25px',
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100vw',
    height: '100%',
    borderRadius: 0,
  },
  boxTablet: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    borderRadius: 0,
  },
  closeIcon: {
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    lineHeight: 0,
    padding: '13px',
    borderRadius: '100%',
  },

  appBar: {
    width: '100%',
    backgroundColor: 'baseColor.color1',
    boxShadow: 'none',
    color: 'white',
    bottom: 0,
    top: 'auto',
    zIndex: 999,
  },
  toolbar: {
    pt: '20px',
    pb: '20px',
  },
  btnAddToOrder: {
    justifyContent: 'space-between',
    fontSize: 18,
    pt: 1.5,
    pb: 1.5,
  },
  input: {
    marginTop: '30px',
    minHeight: '50px',
    height: '100%',
    width: '100%',
    padding: '8px 16px',
    borderRadius: '10px',
    backgroundColor: 'white',
    border: '1px solid black',
    fontSize: '1.6rem',
  },
  contentTablet: {
    width: '100%',
    display: 'flex',
    padding: '94px 109px 43px 112px',
    height: '100%',
  },
  content: {
    width: '100%',
  },
  contentRightTab: {
    paddingLeft: '57px',
    width: '100%',
    height: '100%',
    overflow: 'overlay',
    scrollbarWidth: 'none',
    display: 'flex',
    flexDirection: 'column',
  },
}

export default detailFoodStyle
